
import {IPaginationData, ItaskOrderSearchItem} from '@/@types/global'
import {getTelList} from '@/api/seTel'
import {CommonModule} from '@/store/module/common'
import {UserModule} from '@/store/module/user'
import mapFunc from '@/utils/mapFunc'
import {Component, Vue, Watch} from 'vue-property-decorator'
import AddFilter from './components/addFilter.vue'
import EditForm from '@/views/common/components/editForm.vue'

@Component({
	name: 'myFilter',
	components: {
		AddFilter,
		EditForm
	}
})
export default class MyFilter extends Vue {
	searchData = {
		name: '',
		dateTime: ''
	}
	dialogVindicate = false

	get handleInit() {
		return CommonModule.isNeedInitData
	}

	get menuId() {
		return CommonModule.menuId
	}

	get subMenuId() {
		return CommonModule.currentSubMenuID
	}

	get userInfo() {
		return UserModule.userInfo
	}

	get SelectedSubItem(): any {
		return CommonModule.selectedSubItem
	}

	@Watch('handleInit', {immediate: true})
	handleInitData() {
		if (this.handleInit) {
			this.paginationData.currentPage = 1
			this.initTableList()
			CommonModule.HANDLE_INIT_STORE_DATA(false)
		}
	}

	mounted() {
		this.initTableList()
	}

	handleSearch() {
		// 点击搜索按钮
		this.paginationData.currentPage = 1
		this.initTableList()
	}

	handleReset() {
		// 点击重置按钮
		this.searchData.name = ''
		this.searchData.dateTime = ''
	}

	handleCreate() {
		if (this.SelectedSubItem.CanOrder === 0) {
			this.dialogVindicate = true
			return
		}
		// 新建代筛任务
		this.dialogVisible = true
		this.$nextTick(() => {
			const ref = this.$refs.addFilterRef as AddFilter
			ref.init()
		})
	}

	dialogVisible = false

	handleClose() {
		// 弹框关闭事件
	}

	handleConfirm() {
		// 弹框点击确定提交事件
		const ref = this.$refs.addFilterRef as AddFilter
		ref.handleConfirm()
	}

	handleSuccess() {
		this.dialogVisible = false
		this.editDialogVisible = false
		this.paginationData.currentPage = 1
		this.initTableList()
	}

	isLoading = false
	taskOrderList = []

	initTableList() {
		// 初始化列表数据
		const typeId = localStorage.getItem('subMenuId') || ''
		const params: ItaskOrderSearchItem = {
			typeId,
			key: this.searchData.name,
			date: this.searchData.dateTime,
			pageNum: this.paginationData.currentPage,
			limit: this.paginationData.pageSize
		}
		this.isLoading = true
		getTelList(params)
			.then((res: any) => {
				this.taskOrderList = res.data.map((item: any) => {
					return {
						...item,
						status_: mapFunc.formatStatus(item.Status)
					}
				})
				this.paginationData.total = res.total
			})
			.catch(err => {
				this.$message.error(err.msg)
			})
			.finally(() => {
				this.isLoading = false
			})
	}

	handleCreateChange(item: any, row: any) {
		switch (item) {
			case 1:
				this.downloadFile(row.TaskGuid, 'export')
				break
			case 2:
				this.downloadFile(row.TaskGuid, 'downOrginFile')
				break
			case 3:
				this.handleEdit(row)
				break
			default:
				console.log(4)
				break
		}
	}

	// 下载文件
	downloadFile(id: string, type: string) {
		const preFix = window.location.protocol + '//' + window.location.host
		window.open(`${preFix}/api/taskOrder/${type}?taskGuid=${id}`)
	}

	// 编辑任务
	editDialogVisible = false
	editFormData: any = {}

	handleEdit(row: any) {
		if (this.userInfo.roleID === 1) {
			// 只有管理员权限才可以编辑
			this.editDialogVisible = true
			this.editFormData = row
			this.$nextTick(() => {
				const editFormRef = this.$refs.editFormRef as EditForm
				editFormRef.initDialog(row)
			})
		}
	}

	handleSave() {
		const editFormRef = this.$refs.editFormRef as EditForm
		editFormRef.handleSave()
	}

	// 分页器
	paginationData: IPaginationData = {
		// 表单数据
		currentPage: 1,
		sizes: [10, 30, 50, 100],
		pageSize: 50,
		total: 0
	}

	handleSizeChange(val: number) {
		this.paginationData.pageSize = val
		this.initTableList()
	}

	handleCurrentChange(val: number) {
		this.paginationData.currentPage = val
		this.initTableList()
	}
}
